import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sort"
})
export class SortPipe implements PipeTransform {
  transform(array: any[], field?: string): any[] {
    array.sort((a: any, b: any) => {
      let firstValue = field === null ? a : a[field];
      let secondValue = field === null ? b : b[field];

      if (firstValue < secondValue) {
        return -1;
      } else if (firstValue > secondValue) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
